// Niveles de la estructura sobre los que se arma una vista (ver AuthContext).
export const NIVELES_SISTEMA = {
  CONFEDERACION: 'confederacion',
  FEDERACION: 'federacion',
  COOPERATIVA: 'cooperativa',
  AFILIADO: 'afiliado',
};
